import { PreceptorsList } from 'presentation/app/modules/Professionals/Preceptors/pages/preceptors-list';
import React from 'react';

export const MakePreceptorsList: React.FC = () => {
  return <PreceptorsList />;
};
